<template>
  <div class="login">
    <div class="form-wrapper">
      <div class="form-title">{{ $t('Login') }}</div>
      <el-form :model="loginForm" label-position="top" status-icon :rules="rules" ref="loginForm" label-width="100px" class="my-form"  v-loading="fullLoading">
        <el-form-item :label="$t('staff id')" prop="number">
          <el-input v-model="loginForm.number" autocomplete="off" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('inputPassword')" prop="password">
          <el-input show-password v-model="loginForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="termsAndConditions" class="terms">
          <el-checkbox-group v-model="loginForm.termsAndConditions">
            <el-checkbox :label="1">
              {{ $t('login accepting') }}
              <router-link :to="{name: 'TermsOfUse'}" target="_blank">{{ $t('Terms of Use') }}</router-link>
              {{ $t('and') }}
              <router-link :to="{name: 'PrivacyPolicy'}"  target="_blank">{{ $t('Privacy Policy') }}</router-link>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="submitWrapper">
          <el-button type="primary" @click="submitForm()" class="submitBtn">{{ $t('LOGIN') }}</el-button>
        </el-form-item>
        <el-form-item class="link">
          <router-link :to="{name: 'ResetPassword'}">{{ $t('Forgot your password') }}</router-link>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      const validateNumber = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('Please input the Staff ID')))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('please input password')))
        } else {
          callback()
        }
      }
      const validateTerms = (rule, value, callback) => {
        if(value !== true) {
          return callback(new Error(this.$t('Please check the Terms of Use')));
        } else {
          callback()
        }
      }
      return {
        fullLoading: false,
        loginForm: {
          number: '',
          password: '',
          termsAndConditions: false,
        },
        rules: {
          number: [
            {validator: validateNumber, trigger: 'blur'},
            {pattern:/^\d{8}$/,message: this.$t('Between 6 and 20 characters')},
          ],
          password: [
            {validator: validatePassword, trigger: 'blur' },
          ],
          termsAndConditions: [{ validator: validateTerms, trigger: 'blur'}]
        }
      };
    },
    methods: {
      submitForm() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.fullLoading = true
            const loginData = {
              account: this.loginForm.number,
              password: this.loginForm.password,
            }
            this.axios.post('/api/employee/auth/login', loginData)
              .then((res) => {
                if (res.code === 200) {
                  localStorage.username = res.data.first_name+' '+ res.data.last_name
                  localStorage.employee_quota = res.data.employee_quota
                  localStorage.employee_rate = JSON.stringify(res.data.employee_rate)
                  localStorage.fnf_quota = res.data.fnf_quota
                  localStorage.fnf_rate = JSON.stringify(res.data.fnf_rate)
                  this.$store.commit('stateChange', {k: 'username', v: res.data.first_name+' '+ res.data.last_name})
                  this.$store.commit('stateChange', {k: 'employeeQuota', v: res.data.employee_quota})
                  this.$store.commit('stateChange', {k: 'employeeRate', v: res.data.employee_rate})
                  this.$store.commit('stateChange', {k: 'fnfQuota', v: res.data.fnf_quota})
                  this.$store.commit('stateChange', {k: 'fnfQuota', v: res.data.fnf_rate})
                  // 是否需要强制改密码
                  if(res.data.force_change_pwd == true) {
                    // 提示并跳转页面强制修改密码
                    localStorage.isForceChange = true
                    this.$alert(this.$t('Password must be changed'), {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                      callback: () => {this.$router.push({name: 'UserCenter'})}
                    })
                  } else {
                    // 跳转页面首页
                    this.$router.push({name: 'Home'})
                  }
                } else if (res.code === 211) {
                  this.$alert(res.msg, {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                      callback: () => {
                      this.$router.push({name: 'ResetPassword'})
                    }
                  }).then(() => {
                    this.$router.push({name: 'ResetPassword'})
                  });
                } else {
                  this.$alert(res.msg, {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                  })
                }
              }).finally(() => {
              this.fullLoading = false
            })
          } else {
            return false;
          }
        });
      },
    }
  }
</script>
